const GENERALS = {
    MI_COLEGIO: 'Mi Colegio',
    PARRAFO_LOGIN: 'Tu espacio de trabajo; Actualiza tus datos, consulta tus trámites y accede a todos los servicios del colegio.',
    CATALAN: 'Catalán',
    ESPANIOL: 'Español',
    IDIOMA: 'Idioma',
    PARRAFO_RECUPERAR_COLEGIADO: 'Si ha olvidado la clave, introduzca su Numero colegiado y pulse aquí',
    PARRAFO_RECUPERAR_PRECOLEGIADO: 'Si ha olvidado la clave, introduzca su Numero precolegiado y pulse aquí',
    PARRAFO_RECUPERAR_EXTERNO: 'Si ha olvidado la clave, introduzca su NIF y pulse aquí',
    IDENTIFICATE: 'Identifícate',
    ESPACIO_CORPORATIVO: 'Espacio Corporativo',
    ESPACIO_DE_TRABAJO: 'Espacio de Trabajo',
    XARXA_EBCN: 'XARXA e-BCN',
    VUELVE_A_VER: 'Vuelve a Ver',
    DATOS_PROFESIONALES: 'Datos profesionales',
    DATOS_ACCESO_CONSUMIDOR: `Datos de acceso al consumidor y usuario`,
    DATOS_GUIA_PROFESIONAL: 'Datos de la Guía de Profesionales',
    DATOS_CONTACTO_RELACION_COLEGIO: 'Datos de contacto y relación con el Colegio',

    REGISTRO_TECNICOS_CERTIFICADORES: 'Registro de Técnicos Certificadores',
    SOLICITUD_CERTIFICADO_COLEGIACION: 'Solicitud de Certificado de Colegiación',
    CORREO_ELECTRONICO_CORPORATIVO: 'Correo Electrónico Corporativo',
    DL_ABSTRACT: 'DL Abstract',
    SOLICITUDES: 'Solicitudes',
    SELLO_INGENIERO_GRADUADO_INDUSTRIAL: 'Sello del ingeniero graduado en el ámbito industrial',
    SELLO_INGENIERO_TECNICO_INDUSTRIAL: 'Sello del ingeniero técnico industrial',
    SELLO_INGENIERO_TECNICO_DISENIO_INDUSTRIAL: `Sello del ingeniero técnico en diseño industrial`,
    SELLO_SOCIEDADES_PROFESIONALES: `Sello de sociedades profesionales de ingeniería`,
    SOLICITUD_CARNET_COLEGIADO: `Solicitud de carné de colegiado`,
    SELLOS: 'Sellos',
    NOMBRE_DE_EMPRESA: `Nombre de la empresa`,
    SECTOR: 'Sector',
    AREA_DE_aCTUACION: 'Área de actuación',
    POSICION_O_CARGO: 'Posición o cargo',
    DOMICILIO: 'Domicilio',
    POBLACION: 'Población',
    TELEFONO_1: 'Teléfono 1',
    TELEFONO_2: 'Teléfono 2',
    TELEFONO_MOVIL: 'Teléfono Móvil',
    TELEFONO_CONTACTO: 'Teléfono de Contacto',
    FAX: 'FAX',
    EMAIL: 'Email',
    WEB: 'Web',
    ACTUALIZAR_DATOS: 'Actualizar datos',
    ELIMINAR_DATOS: 'Eliminar datos',
    BORRAR_DATOS: 'Borrar datos',
    MODIFICAR_CONTRASENIA: 'Modificar contraseña',
    CERRAR_SESION: 'Cerrar sesión',
    COLEGIADO: 'Colegiado',
    PRECOLEGIADO: 'Precolegiado',
    EXTERNO: 'Externo',
    NUMERO_COLEGIADO: 'Número colegiado',
    CODIGO: 'Código',
    CLAVE: 'Clave',
    NUMERO_PRECOLEGIADO: 'Número precolegiado',
    NIF: 'NIF',
    CERTIFICADO_DIGITAL: 'Certificado digital',
    CERTIFICADO_DIGITAL_DESCRIPCION: 'Introduce tu NIF y selecciona tu certificado cuando el navegador te lo pida.',
    CERTIFICADO_NO_DETECTADO: 'No se ha recibido ningún certificado. Vuelve a intentarlo y selecciona tu certificado cuando el navegador te lo solicite.',
    CERTIFICADO_INVALIDO: 'El NIF o el certificado no son válidos.',
    CERTIFICADO_SIN_SERVICIO: 'El servicio de acceso con certificado no está disponible en este momento.',
    CERTIFICADO_NIF_INVALIDO: 'El NIF no es válido o no corresponde al certificado presentado.',
    CERTIFICADO_ERROR_SERVIDOR: 'No se ha podido validar el certificado. Inténtalo de nuevo más tarde.',
    CERTIFICADO_ERROR_CONEXION: 'No se ha podido contactar con el servicio de certificados. Comprueba tu conexión e inténtalo de nuevo.',
    CERTIFICADO_ERROR_GENERICO: 'No se ha podido iniciar sesión con el certificado. Inténtalo de nuevo.',

    BUSCADOR_DOCUMENTACION_SEGUIMIENTO: 'Buscador de documentación y conocimiento',
    TECNOVISAT: 'Tecnovisat',
    GESTIONA_TUS_INSCRIPCIONES: 'Gestiona tus inscripciones',
    CAMPUS_VIRTUAL: 'Campus virtual',
    BOLSA_DE_TRABAJO: 'Bolsa de trabajo',
    ALTA_GUIA_PROFESIONALES: 'Alta Guía de profesionales',
    ALTA_REGISTRO_CERTIFICADORES_EFICIENCIA_ENERGETICA: 'Alta registro de certificadores de eficiencia energética',
    PERITOS_TERCEROS_ADMINISTRACION: 'Peritos y terceros para la administración',
    SLAM: 'Slam',
    TOOLBOX: 'Tool Box',
    // Títulos de los grupos colapsables del menú lateral (ver PrivateRouter/Navleft)
    GRUPO_FORMACION: 'Formación',
    GRUPO_SERVICIOS: 'Servicios profesionales',
    GRUPO_TRAMITES: 'Trámites',
    _CONTACTO: 'Actualización de datos',
    COGNOMS: 'Apellidos',
    NOMS: 'Nombres',
    Q_HABILITADO: '¿Habilitado?',
    TITULACIONES: 'Titulaciones',
    OTRAS_TITULACIONES: 'Otras titulaciones',
    FECHA_NACIMIENTO: 'Fecha nacimiento',
    ESTADO: 'Estado',
    OTRO_TELEFONO: 'Otro teléfono',

    EMPRESAS: 'Empresas',
    BUSCAR_AUTORIZAR_EMPRESA: 'Buscar y autorizar empresa',
    AUTORIZAR_EMPRESA: 'Autorizar empresa',
    LISTADO_EMPRESAS: 'Listado de empresas',
    BUSCAR_EMPRESA: 'Buscar empresa',
    BUSCAR_EMPRESA_DESCRIPCION: 'Busca una empresa por nombre o CIF',
    BUSCAR_CIF_NOMBRE: 'Buscar por CIF o nombre de la empresa',
    REALIZAR_BUSQUEDA: 'Realizar búsqueda',
    ENVIAR_AUTORIZACION: 'Enviar autorización',
    EMPRESA_AUTORIZADA: 'Empresa autorizada',
    EMPRESA_NO_AUTORIZADA: 'Empresa no autorizada',
    EMPRESA_RECHAZADA: 'Empresa rechazada',
    PENDIENTE: 'Pendiente',
    AUTORIZACION_SOLICITADA: 'Se ha enviado correctamente la solicitud de autorización',
    ENTRAR: 'Entrar',
    VOLVER: 'Volver',
    ACCIONES: 'Acciones',
    INICIO: 'Inicio',
    ACTIVITATS_DISPONIBLES: 'Actividades disponibles',
    NOTICIAS: 'Noticias',
    SENSE_NOTICIES: 'No hay noticias disponibles',
    ACTIVITATS_DISPONIBLES_NOTICIAS: 'Actividades disponibles y noticias',
    FACTURAS: 'Facturas',
    FACTURAS_ACTIVIDADES: 'Facturas de actividades',
    FACTURAS_VISADO: 'Facturas de visado',
    BUSCAR: 'Buscar',
    TODOS_TIPOS: 'Todos los tipos',
    ID: 'ID',
    NUM_FACTURA: 'Nº factura',
    FECHA_FACTURA: 'Fecha factura',
    TIPO_FACTURA: 'Tipo',
    SENSE_FACTURES: 'No hay facturas',
    CONCEPTO: 'Concepto',
    IMPORTE: 'Importe',
    VISADO_DUMMY_INFO: 'Servicio de facturas de visado en preparación (datos de muestra)',
    VISADO_PAGADA: 'Pagada',
    VISADO_PENDIENTE: 'Pendiente',
    MIS_ACTIVIDADES: 'Mis actividades',
    PERSONAS: 'Personas',
    PERSONAS_AUTORIZADAS: 'Personas autorizadas',
    MIS_DATOS: 'Mis datos',
    USUARIOS_AUTORIZADOS: 'Usuarios autorizados',
    NUEVO: 'Nuevo',
    NUEVO_USUARIO_AUTORIZADO: 'Nuevo usuario autorizado',
    AUTORIZAR_USUARIO: 'Autorizar usuario',
    AUTORIZACION_SIN_CORREO: 'El usuario quedará autorizado en la empresa de forma inmediata, sin enviar ningún correo',
    USUARIO_AUTORIZADO: 'Usuario autorizado correctamente',
    ERROR_AUTORIZAR_USUARIO: 'No se ha podido autorizar al usuario en la empresa',
    USUARIO_AUTORIZADO_ELIMINADO: 'Usuario desvinculado de la empresa',
    ELIMINAR_USUARIO_AUTORIZADO: 'Eliminar usuario autorizado',
    ELIMINAR_USUARIO_AUTORIZADO_CONFIRMACION: '¿Estás seguro de que deseas desvincular a este usuario autorizado de la empresa?',
    AUTORIZADA: 'Autorizada',
    RECHAZADA: 'Rechazada',
    FECHA: 'Fecha',
    DATOS_EMPRESA: 'Datos de la empresa',
    TELEFONO: 'Teléfono',
    NOMBRE_CONTACTO: 'Nombre de la persona de contacto',
    APELLIDOS_CONTACTO: 'Apellidos de la persona de contacto',
    SIARC: 'SIARC',
    CATEGORIAS: 'Categorías',
    DEPARTAMENTOS: 'Departamentos',
    DOM_VALIDADA: 'Domiciliación validada',
    SI_DOM: 'SI DOM',
    GUARDAR_DATOS: 'Guardar cambios',
    DATOS_EMPRESA_ACTUALIZADOS: 'Los datos de la empresa se han guardado correctamente.',
    ERROR_GUARDAR_DATOS: 'No se han podido guardar los datos de la empresa.',
    PROXIMAMENTE: 'Próximamente',
    SECCION_EN_DESARROLLO: 'Esta sección está en desarrollo',
    NOTICIA: 'Noticia',
    VEURE_NOTICIA: 'Ver noticia',
    MES_INFORMACIO: 'Más información',
    DATA: 'Fecha',
    LLOC: 'Lugar',
    BUSCAR_ACTIVIDAD: 'Buscar actividad',
    SENSE_ACTIVITATS: 'No hay actividades que coincidan con la búsqueda',
    LISTADO_INSCRIPCIONES: 'Listado de inscripciones',
    SENSE_INSCRIPCIONES: 'No hay inscripciones que coincidan con la búsqueda',
    PERSONA: 'Persona',
    ACTIVIDAD: 'Actividad',
    PRECIO: 'Precio',
    PERMANENTE: 'Permanente',
    ENCUESTA: 'Encuesta',
    ACTIVIDADES_ASIGNADAS: 'Actividades asignadas',
    FECHA_INICIO: 'Fecha inicio',
    PORCENTAJE_ASISTENCIA: '% Asistencia',
    TODOS_ESTADOS: 'Todos los estados',
    BUSCAR_CURSO: 'Buscar curso',
    SENSE_CURSOS: 'No hay cursos que coincidan con la búsqueda',
    VER_DETALLE: 'Ver detalle',
    CURSO_DETALLE: 'Detalle del curso',
    ACTIVITAT_PROGRAMA: 'Programa',
    PLACES: 'Plazas',
    ACTIVITAT_DETALLE: 'Detalle de la actividad',
    ACTIVITAT_ESTADO: 'Estado',
    ACTIVITAT_TIPO: 'Tipo',
    ACTIVITAT_FECHAS: 'Fechas',
    ACTIVITAT_HORARIO: 'Horario',
    ACTIVITAT_DURACION: 'Duración',
    ACTIVITAT_LUGAR: 'Lugar',
    ACTIVITAT_DISPONIBILIDAD: 'Disponibilidad y tarifas',
    ACTIVITAT_PLAZAS_TOTALES: 'Plazas totales',
    ACTIVITAT_PLAZAS_DISPONIBLES: 'Plazas disponibles',
    ACTIVITAT_FECHA_LIMITE_PAGO: 'Fecha límite de pago',
    ACTIVITAT_COSTES_INSCRIPCION: 'Costes de inscripción',
    ACTIVITAT_INSCRIBIR: 'Inscribir',
    ACTIVITAT_NO_DISPONIBLE: 'No disponible',
    ACTIVITAT_RESUMEN: 'Resumen',
    ACTIVITAT_OBJETIVOS: 'Objetivos',
    ACTIVITAT_ORGANIZADOR: 'Organizador',
    ACTIVITAT_DESTINATARIOS: 'Destinatarios',
    ACTIVITAT_PROFESORADO: 'Profesorado',
    ACTIVITAT_DERECHO_INSCRIPCION: 'Derecho de inscripción',
    ACTIVITAT_DOCUMENTACION: 'Documentación',
    ACTIVITAT_OBSERVACIONES: 'Observaciones',
    ACTIVITAT_INSCRITOS: 'Inscritos',
    ACTIVITAT_SIN_INSCRITOS: 'No hay personas inscritas',
    SIN_RESULTADOS: 'No se han encontrado resultados',
    DETALLE_EMPRESA: 'Detalle de la empresa',
    SIN_ACCESO_EMPRESA: 'Acceso no autorizado a la empresa',
    ERROR_CARGAR_EMPRESA: 'No se ha podido cargar la información de la empresa',
    SELECCIONA_UNA_EMPRESA: 'Selecciona una empresa de la lista para ver su detalle',
    EMPRESA_RECIBIRA_SOLICITUD: 'Al enviar la solicitud, la empresa recibirá un aviso para completar el proceso de autorización',
    // Alta de empresa desde el modal de búsqueda (cuando la empresa no existe).
    EMPRESA_NO_ENCONTRADA: 'No se ha encontrado la empresa',
    EMPRESA_NO_ENCONTRADA_DESCRIPCION: 'Si la empresa no está en el catálogo, puedes darla de alta y enviarle la solicitud de autorización.',
    REGISTRAR_EMPRESA: 'Registrar empresa',
    DATOS_EMPRESA_NUEVA: 'Datos de la empresa',
    DATOS_CONTACTO_NUEVA: 'Datos de la persona de contacto',
    CONTACTO_NUEVA_DESCRIPCION: 'Nombre y apellidos de la persona que representa a la empresa.',
    CATEGORIAS_Y_DEPARTAMENTOS: 'Categorías y departamentos',
    RAZON_SOCIAL: 'Razón social',
    TELEFONO_PRINCIPAL: 'Teléfono principal',
    EMAIL_PRINCIPAL: 'Email principal',
    EMAIL_CONTACTO: 'Email de contacto',
    ALTA_REQUIERE_AUTORIZACION: 'Al registrar la empresa se le envía la solicitud de autorización. El acceso queda pendiente hasta que la empresa la acepte.',
    VOLVER_A_BUSQUEDA: 'Volver a la búsqueda',
    EMPRESA_REGISTRADA: 'La empresa se ha registrado correctamente',
    EMPRESA_REGISTRADA_ESPERA: 'Su acceso queda pendiente hasta que la empresa acepte la solicitud.',
    EMPRESA_YA_REGISTRADA: 'Ya existe una empresa registrada con este CIF/NIF',
    ERROR_REGISTRAR_EMPRESA: 'No se ha podido registrar la empresa.',
    // Guía paso a paso del módulo (modal ModalInstrucciones).
    GUIA_EMPRESAS: 'Cómo funciona el acceso de una empresa',
    // Etiqueta corta del botón que abre la guía: el título completo no cabe en el
    // header junto al de buscar empresa.
    GUIA_EMPRESAS_CORTA: 'Guía',
    GUIA_EMPRESAS_DESCRIPCION: 'Estos son los pasos que debe seguir una empresa para empezar a usar su espacio autorizado. El acceso se activa por correo: hasta que la empresa no acepta la solicitud, no se puede entrar.',
    GUIA_PASO_DONDE: 'Dónde',
    GUIA_PASO_1_TITULO: 'Registrar la empresa',
    GUIA_PASO_1_DESCRIPCION: 'Busca la empresa por CIF o razón social. Si no está en el catálogo, pulsa «Registrar empresa» y completa el alta: datos de la empresa, persona de contacto, categorías y departamentos.',
    GUIA_PASO_1_DONDE: 'Empresas › Buscar y autorizar empresa',
    GUIA_PASO_2_TITULO: 'Esperar la confirmación',
    GUIA_PASO_2_DESCRIPCION: 'Al enviar la solicitud, la empresa recibe un aviso en su correo con un enlace para completarla. Mientras no lo acepta, aparece en estado pendiente y el botón Entrar está desactivado.',
    GUIA_PASO_2_DONDE: 'Listado de empresas',
    GUIA_PASO_3_TITULO: 'Ya se puede entrar',
    GUIA_PASO_3_DESCRIPCION: 'Cuando la empresa acepta la solicitud, el estado pasa a autorizada y se activa el botón Entrar. Ahí empieza el espacio de la empresa.',
    GUIA_PASO_3_DONDE: 'Listado de empresas',
    GUIA_PASO_4_TITULO: 'Añadir personas',
    GUIA_PASO_4_DESCRIPCION: 'Pulsa «Buscar y autorizar persona». Si la persona no existe, se puede registrar desde el mismo buscador. Cada persona recibe su propia solicitud y debe aceptarla.',
    GUIA_PASO_4_DONDE: 'Empresas › Personas',
    GUIA_PASO_5_TITULO: 'Inscribir personas en actividades',
    GUIA_PASO_5_DESCRIPCION: 'Marca las personas, elige la actividad y pulsa Inscribir. Una inscripción se puede anular más adelante.',
    GUIA_PASO_5_DONDE: 'Empresas › Inicio',
    GUIA_PASO_6_TITULO: 'Consultar las actividades inscritas',
    GUIA_PASO_6_DESCRIPCION: 'Consulta y gestiona todas las inscripciones de la empresa.',
    GUIA_PASO_6_DONDE: 'Empresas › Mis actividades',
    GUIA_PASO_7_TITULO: 'Consultar el catálogo de cursos',
    GUIA_PASO_7_DESCRIPCION: 'Todos los cursos disponibles, con su detalle.',
    GUIA_PASO_7_DONDE: 'Empresas › Catálogo de cursos',
    GUIA_PASO_8_TITULO: 'Consultar las facturas',
    GUIA_PASO_8_DESCRIPCION: 'Facturas emitidas y su detalle.',
    GUIA_PASO_8_DONDE: 'Empresas › Facturas',
    GUIA_PASO_9_TITULO: 'Gestionar los datos y los usuarios autorizados',
    GUIA_PASO_9_DESCRIPCION: 'Datos de la empresa (dirección, contacto, categorías y departamentos) y altas o bajas de las personas autorizadas a entrar en su espacio.',
    GUIA_PASO_9_DONDE: 'Empresas › Mis datos',
    LISTADO_PERSONAS: 'Listado de personas',
    BUSCAR_AUTORIZAR_PERSONA: 'Buscar y autorizar persona',
    BUSCAR_PERSONA: 'Buscar persona',
    BUSCAR_PERSONA_DESCRIPCION: 'Busca una persona por nombre o NIF',
    BUSCAR_NOMBRE_NIF: 'Buscar por nombre o NIF',
    SELECCIONA_UNA_PERSONA: 'Selecciona una persona de la lista para ver su detalle',
    PERSONA_AUTORIZADA: 'Persona autorizada',
    PERSONA_NO_AUTORIZADA: 'Persona no autorizada',
    PERSONA_RECHAZADA: 'Persona rechazada',
    PERSONA_RECIBIRA_SOLICITUD: 'Al enviar la solicitud, la persona recibirá un aviso para completar el proceso de autorización',
    NOMBRE: 'Nombre',
    DETALLE_PERSONA: 'Detalle de la persona',
    ELIMINAR_PERSONA: 'Eliminar persona',
    ELIMINAR: 'Eliminar',
    CANCELAR: 'Cancelar',
    ELIMINAR_PERSONA_CONFIRMACION: '¿Estás seguro de que deseas desvincular a esta persona de la empresa?',
    PERSONA_ELIMINADA: 'La persona se ha desvinculado de la empresa',
    INSCRIPCION_PERSONAS: 'Inscripción de personas',
    INSCRIBIR: 'Inscribir',
    PERSONAS_INSCRITAS_OK: 'Inscripciones realizadas correctamente',
    ANULAR_INSCRIPCION: 'Anular inscripción',
    INSCRIPCION_ANULADA_OK: 'Inscripción anulada',
    CONTACTO: 'Contacto',
    CIF: 'CIF',
    DIRECCION: 'Dirección',
    FILAS_POR_PAGINA: 'Filas por página:',
    DE: 'de',
    ENVIAR_SOLICITUD: 'Enviar solicitud',
    LIMPIAR: 'Limpiar',
    ENVIAR: 'Enviar',
    CONFIRMAR: 'Confirmar',
    DESCARGAR_SELLO: 'Descargar sello',
    SOLICITAR_SELLO: 'Solicitar sello',
    ACTUALIZA: 'Actualiza',
    RESTABLECER_CLAVE: 'Restablecer clave',
    USUARIO: 'Usuario',
    CONFIRMAR_CLAVE: 'Confirmar clave',
    PARRAFO_OPERACION_EXITO: 'Se ha realizado la operación con éxito',
    CODIGO_POSTAL: 'Código postal',
    PAIS: 'País',
    PROVINCIA: 'Provincia',
    RECORTAR_IMAGEN: 'Recortar imagen',
    MANTENER_ORIGINAL: 'Mantener original',
    CONTRASENIA: 'Contraseña',
    CONFIRMAR_CONTRASENIA: 'Confirmar contraseña',
    PRESENTACION: 'Presentación',
    CAMPO_ENLACE: 'Campo enlace',
    DAR_DE_BAJA: 'Dar de baja',
    NOMBRE_EMPRESA_FORMACION_ADICIONAL: 'Nombre de empresa y formación adicional',
    INICIAR_SESION: 'Iniciar Sesión',
    COMARCA: 'Comarca',
    INSCRIPCION_LISTA_GENERAL_PERITOS_JUDICIALES: 'Inscripción en el listado general de peritos judiciales',
    DOCUMENTOS_ACCESO: 'Documentos acceso',
    INSCRIPCION_LISTA_PERITOS_JUDICIALES_ASISTENCIA_RECONOCIDA: 'Inscripción en el listado de peritos judiciales en procedimientos con asistencia jurídica gratuita reconocida',
    INSCRIPCION_LISTA_PERITOS_TERCEROS: `Inscripción en el listado de peritos terceros para valoraciones y tasaciones con las administraciones`,
    INSCRIPCION_LISTA_COLEGIADOS: 'Inscripción en el listado de colegiados dispuestos a actuar como peritos en relación con el artículo 50 de la Ley del Notariado',
    AREA_DE_COLEGIACION: 'Área de colegiación',
    CATALOGO_DE_CURSOS: `Catálogo de cursos`,
    SOLICITUD_OTED: 'Alta Guía ETEC',
    CERTIFICADO: 'Certificado',
    SELECCIONAR_UN_GRUPO: `Debe seleccionar al menos un proyecto del grupo`,
    DEBE_SELECCIONAR_PROYECTO: `Debe seleccionar el proyecto`,
    ALMENOS_UN_HIJO: `y al menos uno de sus hijos`,
    ERRORES_DE_VALIDACION: `Errores de validación`,
    P_ERRORES_DE_VALIDACION_1: `Hemos detectado que faltan datos obligatorios o hay información incorrecta. Por favor revisa los siguientes campos. Estos también se marcarán en rojo dentro del formulario para facilitar su corrección.`,
    CERRAR: `Cerrar`,
    GENERANDO: `Generando`,
    GENERAR_DOCUMENTO: `Generar Documento`,
    ERRORES_DE_VALIDACION_PROYECTO: "Debe seleccionar al menos un proyecto de",
    MENSAJE_LOADING_SOLICITUD_OTED: "Verificando datos de la solicitud, por favor espera...",
    FORMULARIO_OTED_TITULO: "Solicitud de incorporación al listado de Ingeniero/a de grado y/o ingeniero/a técnico/a energético/a colegiado/a (en adelante ETEC)",
    DETALLE_SOLICITUD_OTED_TITULO: "Resumen de tu solicitud en ETEC",
    FORMULARIO_OTED_INPUT_NOMBRE: "Nombre y apellidos",
    FORMULARIO_OTED_INPUT_N_COLEGIADO: "Nº. Colegiado",
    FORMULARIO_OTED_INPUT_ESPECIALIDAD: "Título y especialidad",
    FORMULARIO_OTED_INPUT_TELEFONO: "Teléfono de contacto",
    FORMULARIO_OTED_INPUT_CORREO: "Correo electrónico",
    FORMULARIO_OTED_INPUT_COMPANIA: "Compañía seguros",
    FORMULARIO_OTED_INPUT_N_POLZA: "Nº. Póliza",
    FORMULARIO_OTED_INPUT_IMPORTE: "Importe cobertura (€)",
    FORMULARIO_OTED_INPUT_CONDICIONES: "Declaro que he leído y acepto las condiciones expuestas en este formulario",
    FORMULARIO_OTED_MANIFESTO: "Manifiesto",
    FORMULARIO_OTED_ACUERDOS: "Acuerdos",
    POLZA_COLEGIADO: "Póliza colectiva Colegio (recordar que los proyectos y/o diseño de instalaciones de seguridad industrial están sujetos a que los trabajos sean registrados o visados por el Colegio para disponer de cobertura)",
    POLZA_EXTERNA: "Póliza colectiva Colegio <span style='font-style: italic; text-decoration: underline;'>recordar que los proyectos y/o diseño de instalaciones de seguridad industrial están sujetos a que los trabajos sean registrados o visados por el Colegio para disponer de cobertura</span>",
    ACTUALIZACION: `Actualización`,
    ACTUALIZACION_DATOS_CONTACTO: `Actualización de datos de contacto`,
    SOLICITUD_ACTUALIZACION_DATOS_CONTACTO: `Solicitud de actualización de datos de contacto`,
    DATOS_ENVIADOS_CORRECTAMENTE: `Datos enviados correctamente, pendientes de modificación`,
    EMAIL_PERSONAL: `Email personal`,
    EMAIL_PROFESIONAL: `Email profesional`,
    ACTUALIZACION_DATOS: 'Actualización de datos',
    
}

const VALIDATIONS = {
    VALID_EXISTE_NUMERO_COLEGIADO: 'El número de colegiado es obligatorio.',
    VALID_EXISTE_CLAVE: 'La clave es obligatoria.',
    VALID_CONFIRMAR_CLAVE: 'Las claves no son las mismas.',
    VALID_EXISTE_NOMBRE_SOCIEDAD: 'El nombre de la sociedad es obligatorio.',
    VALID_EXISTE_CAMPO_DEFAULT: 'El campo es obligatorio.',
    VALID_CORRECT_EMAIL: 'Por favor, introduzca una dirección de correo válida.',
    VALID_CORRECT_MOVIL: 'El número de móvil sólo puede contener dígitos (sin espacios, puntos,...)',
}

const lang = {
    ES: {
        ...GENERALS,
        ...VALIDATIONS
    }
}

export default lang;